/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import get from 'lodash/get';
import { FontIcon } from 'office-ui-fabric-react/lib/Icon';
import { Text } from 'office-ui-fabric-react/lib/Text';
import DetailsList from '../DetailsList';
import Link from '../Link';
import styles from './StatementActionRequired.style';
import { formatDateString, formatNumberWithCommas } from '../../utils';

const StatementActionRequired = ({ items, className: classNameProp, ...other }) => {
  const columns = [
    {
      key: 'action',
      name: 'action',
      headerClassName: styles.iconColumnHeader,
      arianame: 'icon',
      isIconOnly: true,
      fieldName: 'icon',
      minWidth: 8,
      maxWidth: 8,
      columnActionsMode: 0,
      onRender: () => {
        return (
          <div className={styles.actionColumn}>
            <FontIcon iconName="StatusTriangleExclamation" arianame="StatusTriangleExclamation" />
          </div>
        );
      },
    },
    {
      key: 'statement',
      name: 'Statement',
      fieldName: 'statement',
      columnActionsMode: 0,
      minWidth: 320,
      maxWidth: 320,
      onRender: item => {
        return (
          <div className={styles.statement}>
            {get(item, 'partnerName')} / {get(item, 'contractName')}
          </div>
        );
      },
    },
    {
      key: 'period',
      name: 'Period',
      fieldName: 'period',
      columnActionsMode: 0,
      minWidth: 80,
      maxWidth: 80,
      isSorted: true,
      isSortedDescending: true,
      onRender: item => {
        return <div>{formatDateString(item.statementEndDate, 'MMM yyyy')}</div>;
      },
    },
    {
      key: 'paymentDueDate',
      name: 'Payment Due Date',
      fieldName: 'paymentDueDate',
      columnActionsMode: 0,
      minWidth: 80,
      maxWidth: 80,
      isSorted: true,
      isSortedDescending: true,
      onRender: item => {
        return <div>{formatDateString(item.paymentDueDate)}</div>;
      },
    },
    {
      key: 'payment',
      name: 'payment',
      fieldName: 'totalRoyaltyEarnedCC',
      columnActionsMode: 0,
      minWidth: 80,
      maxWidth: 80,
      onRender: item => {
        const royalty = get(item, 'totalRoyaltyEarnedCC', 0);
        return (
          <div className={styles.payment}>
            {formatNumberWithCommas(royalty.toFixed(2))} {get(item, 'contractCurrency')}
          </div>
        );
      },
    },
    {
      key: 'review',
      fieldName: 'review',
      minWidth: 148,
      maxWidth: 148,
      onRender: statement => {
        return (
          <Link
            to={`partner/${get(statement, 'partnerAddress')}/statements/${statement.resourceId}`}
          >
            <Text variant="medium" className={styles.textStatement}>
              Review and Approve
            </Text>
            <FontIcon
              iconName="ChevronRight"
              ariaLabel="ChevronRight"
              className={styles.chevronRight}
            />
          </Link>
        );
      },
    },
  ];

  const className = clsx(classNameProp);
  return (
    <DetailsList
      items={items.map(statement => ({
        ...statement,
        key: statement.resourceId,
      }))}
      columns={columns}
      className={className}
      {...other}
    />
  );
};

StatementActionRequired.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      statement: PropTypes.string,
      period: PropTypes.string,
      paymentDueDate: PropTypes.string,
      payment: PropTypes.object,
    }),
  ),
  className: PropTypes.string,
};

StatementActionRequired.defaultProps = {
  items: [],
  className: '',
};

export default StatementActionRequired;
